<template>
  <section class="main-view">
    <div class="container-scroller">
<!--      <Sidebar-->
<!--          :logout="logout"-->
<!--      />-->
      <div class="container-fluid page-body-wrapper">
        <Header :cart="cart"
                :logout="logout"
        />
        <div class="main-panel">
          <div class="content-wrapper">
            <router-view
                :cart="cart"
                :test="test"
                :connected="connected"
                :langKeys="langKeys"
                :images="images"
                :showLoader="showLoader"
                :setUserInfos="setUserInfos"
                :hideLoader="hideLoader"
                :setToken="setToken"
                :isToken="isToken"
                :activatePopupLogin="activatePopupLogin"
                :activatePopupMessage="activatePopupMessage"
                :setActualLng="setActualLng"
                :lngSwitch="lngSwitch"
                :setSwitch="setSwitch"
                :getHomeFilters="getHomeFilters"
                :newUser="newUser"
                :userEmail="userEmail"
                :getImages="getImages"
                :checkDomainName="checkDomainName"
                :domainAvailable="domainAvailable"
                :emailExist="emailExist"
                :websiteNameExist="websiteNameExist"
                :getWebsitesList="getWebsitesList"
                :getDomainList="getDomainList"
                :closePopupNewWebsiteFromDomain="closePopupNewWebsiteFromDomain"
                :isPopupCreateWebsiteFromDomain="isPopupCreateWebsiteFromDomain"
                :activeCreateWebsiteFromDomain="activeCreateWebsiteFromDomain"
                :getClientToken="getClientToken"
                :catalogDomainCreate="catalogDomainCreate"
                :enToSp="enToSp"
                :enToFr="enToFr"
                :languagesCodes="languagesCodes"
                :enToLng="enToLng"
                :isTranslable="isTranslable"
                :languages="languages"
                :getAll="getAll"
                :listALlMailbox="listALlMailbox"/>
          </div> <!-- content wrapper ends -->
          <Footer/>
        </div> <!-- main panel ends -->
      </div> <!-- page-body-wrapper ends -->
    </div>
  </section>
</template>

<script>
  import Header from "./partials/Header";
  import Sidebar from "./partials/Sidebar";
  import Footer from "./partials/Footer";
  export default {
    name: "layout",
    data () {
      return {
        test: "1234",
      }
    },
    props: {
      cart: [] || {},
      connected: Boolean,
      langKeys: [] || {},
      images: [] || {},
      languagesCodes: Function,
      languages: Function,
      enToLng: Function,
      getAll: Function,
      showLoader: Function,
      enToSp: Function,
      enToFr: Function,
      setUserInfos: Function,
      hideLoader: Function,
      setToken: Function,
      logout: Function,
      isToken: Boolean,
      activatePopupLogin: Function,
      activatePopupMessage: Function,
      setActualLng: Function,
      lngSwitch: [] || {},
      setSwitch: Function,
      getHomeFilters: Function,
      newUser: Function,
      userEmail: String,
      getImages: Function,
      checkDomainName: Function,
      domainAvailable: [] || {},
      emailExist: Function,
      websiteNameExist: Function,
      getWebsitesList: Function,
      getDomainList: Function,
      closePopupNewWebsiteFromDomain: Function,
      isPopupCreateWebsiteFromDomain: Function,
      activeCreateWebsiteFromDomain: Function,
      catalogDomainCreate: Function,
      listALlMailbox: Function,
      isTranslable: Function,
      getClientToken: Function,
    },
    components: {
      Header,
      Sidebar,
      Footer
    }
  }
</script>